<template>
  <v-flex v-if="bucket && bucket.id" xs12 sm6 md4 lg3 xl2 px-3 mb-2>
    <v-card color="cardBackground" class="bucket-lid rounded-3"></v-card>
    <v-card color="cardBackground" class="px-4 py-2 mb-2 rounded-3">
      <router-link class="no-link-style" :to="{ path: bucketRoute(this.caseTypeId, bucket.id) }">
        <v-card-title class="pa-0 pb-2 pt-1">
          <v-flex xs12 pr-4 pt-1>
            <h4 class="text-truncate">
              <div class="primary-text body-1 opacity-54 statistics-container">
                <v-icon v-if="showStatistics && statisticsLoading" class="loading">mdi_sync</v-icon>
                <span v-else-if="showStatistics">{{ statistics && statistics.total != null ? statistics.total : "" }} {{ pluralizedCaseTypeName }}</span>
                <span v-else>{{ pluralizedCaseTypeName }}</span>
              </div>
            </h4>
          </v-flex>
          <v-flex xs12>
            <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-3">{{ bucket && bucket.name ? bucket.name : "" }}</h3>
          </v-flex>
        </v-card-title>
      </router-link>
      <v-card-actions class="card-vert-menu">
        <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
          <v-btn flat icon dark slot="activator" class="ma-0 mr-0 pa-0" color="secondary" style="margin-top:calc(50% - 8px) !important; margin-left:-10px !important;" @click.prevent>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile v-if="!isBookmarked" @click="createBookmark()"> <v-icon class="mr-2" color="secondary">bookmark</v-icon>Bookmark this Bucket </v-list-tile>
            <v-list-tile v-if="isBookmarked" @click="removeBookmark()"> <v-icon class="mr-2" color="secondary">bookmark</v-icon>Remove bookmark </v-list-tile>
            <!-- <v-list-tile :to="{ path: bucketEditRoute(this.caseTypeId, bucket.id)}" >
                    <v-icon class="mr-2" color="secondary">edit</v-icon>Edit Bucket
                  </v-list-tile> -->
            <!-- <v-list-tile @click="editOwnerDialog = true">
                    <v-icon class="mr-2" color="secondary">person</v-icon>Edit Bucket Owner
                  </v-list-tile> -->
            <!-- <v-list-tile @click="showShareDialog = true">
                    <v-icon class="mr-2" color="secondary">share</v-icon>Share
                  </v-list-tile> -->
            <v-list-tile @click="showRunTasksDialog = true"> <v-icon class="mr-2" color="secondary">update</v-icon>Run tasks </v-list-tile>
            <v-list-tile v-if="hasExportPermission" @click="exportBucket()"> <v-icon class="mr-2" color="secondary">vertical_align_bottom</v-icon>Export </v-list-tile>
            <v-list-tile @click="refreshStatistics"> <v-icon class="mr-2" color="secondary">refresh</v-icon>Refresh Statistics </v-list-tile>
            <v-list-tile @click="setupBucket()"> <v-icon class="mr-2" color="secondary">edit</v-icon>Configure Bucket </v-list-tile>
            <v-list-tile color="error" @click="showDeleteDialog = true"> <v-icon class="mr-2" color="error">delete</v-icon>Delete Bucket </v-list-tile>
          </v-list>
        </v-menu>
      </v-card-actions>
      <v-dialog v-model="showDeleteDialog" id="buckets-delete-dialog" width="500">
        <v-card class="pa-4">
          <v-card-title class="ma-0 mb-2 pa-0">
            <h2>Delete Bucket</h2>
          </v-card-title>
          <v-card-text class="ma-0 mt-2 mb-1 pa-0">
            <p>Are you sure you want to delete this bucket?</p>
          </v-card-text>
          <v-card-actions class="ma-0 mt-3 pa-0">
            <v-btn @click="deleteBucket" id="bucket-delete-dialog-delete-btn" color="error">
              Yes, delete this bucket
            </v-btn>
            <v-btn @click="showDeleteDialog = false" id="bucket-delete-dialog-cancel-btn" color="secondary">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <RunTasksDialog :showRunTasksDialog="showRunTasksDialog" v-on:tasks-dialog-closed="showRunTasksDialog = false" :bucket="bucket" :case-type-id="caseTypeId"></RunTasksDialog>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
import RunTasksDialog from "@/components/buckets/bucket-elements/RunTasksDialog"
import inflection from "inflection"
import { provider } from "@/provider.js"
import * as Sentry from "@sentry/vue"

export default {
  name: "BucketTile",
  components: { RunTasksDialog },
  props: {
    bucket: { type: Object, required: true },
    groupCaseTypeId: { type: Number },
    groupCaseTypeCode: { type: String },
    permissions: { type: Array, required: true },
    showStatistics: { type: Boolean, default: true },
  },
  data: () => ({
    loading: false,
    bucketsToggled: false,
    statistics: {},
    statisticsLoading: false,
    showDeleteDialog: false,
    showRunTasksDialog: false,
    intersectionObserver: null,
    statisticsLoaded: false,
  }),
  computed: {
    ...mapState({
      routeId: (state) => state.cbroute.params.case_type_id,
      currentUser: (state) => state.currentUser,
      currentCaseTypeCode: (state) => state.caseTypes.current.code,
      bookmarks: (state) => (state.ui.caseWorkMenu && state.ui.caseWorkMenu[0].items && state.ui.caseWorkMenu[0].items[0] && state.ui.caseWorkMenu[0].items[0].childItems && state.ui.caseWorkMenu[0].items[0].childItems ? state.ui.caseWorkMenu[0].items[0].childItems : []),
    }),
    caseTypeId() {
      if (this.groupCaseTypeId) {
        return this.groupCaseTypeId // for homescreen bucket tiles
      } else {
        if (this.routeId) {
          return parseInt(this.routeId, 10)
        } // for bucket tiles in case type sections
      }
      return undefined
    },
    caseTypeCode() {
      if (this.groupCaseTypeCode) {
        return this.groupCaseTypeCode // for homescreen bucket tiles
      } else {
        return this.currentCaseTypeCode // for bucket tiles in case type sections
      }
    },
    pluralizedCaseTypeName() {
      const name = this.bucket && this.bucket.caseTypeName ? inflection.pluralize(this.bucket.caseTypeName) : ""
      return name
    },
    isBookmarked() {
      // Defensive check: ensure bucket and bucket.id exist
      if (!this.bucket || !this.bucket.id) {
        return false
      }
      const bucketRoute = this.bucketRoute(this.caseTypeId, this.bucket.id)
      // Check if current route matches bucket route, use fullPath to match bookmarks with querystring
      const routeToMatch = this.$route && this.$route.path === bucketRoute ? this.$route.fullPath : bucketRoute
      const result = this.bookmarks.find((bookmark) => bookmark.route === routeToMatch || bookmark.route === bucketRoute)
      return !!result
    },
    hasExportPermission() {
      if (this.currentUser.isAccountAdmin) {
        return true
      }
      const result = Helpers.hasPermission(this.permissions, "Export", this.caseTypeCode)
      return result
    },
  },
  methods: {
    bucketRoute: (caseTypeId, bucketId) => `/case-types/${caseTypeId}/buckets/${bucketId}`,
    bucketEditRoute: (caseTypeId, bucketId) => `/case-types/${caseTypeId}/buckets/${bucketId}/edit`,
    async createBookmark() {
      // Defensive check: ensure bucket and bucket.id exist
      if (!this.bucket || !this.bucket.id) {
        console.warn("BucketTile: Cannot create bookmark - bucket or bucket.id is missing")
        return
      }
      const bucketRoute = this.bucketRoute(this.caseTypeId, this.bucket.id)
      // Use fullPath if current route matches bucket route to preserve querystring
      const routeToBookmark = this.$route && this.$route.path === bucketRoute ? this.$route.fullPath : bucketRoute
      const result = await this.$store.dispatch("createBookmark", { route: routeToBookmark, linkText: this.bucket.name })
      if (result) {
        this.$store.commit("setBucketBookmarked", true)
      }
    },
    async removeBookmark() {
      // Defensive check: ensure bucket and bucket.id exist
      if (!this.bucket || !this.bucket.id) {
        console.warn("BucketTile: Cannot remove bookmark - bucket or bucket.id is missing")
        return
      }
      const bucketRoute = this.bucketRoute(this.caseTypeId, this.bucket.id)
      // Use fullPath if current route matches bucket route to match stored bookmark
      const routeToMatch = this.$route && this.$route.path === bucketRoute ? this.$route.fullPath : bucketRoute
      const result = this.bookmarks.find((bookmark) => bookmark.route === routeToMatch || bookmark.route === bucketRoute)
      if (result) {
        await this.$store.dispatch("deleteBookmark", { id: result.id })
      } else {
        this.$store.commit("displayFlashMessage", { message: "ID not found, cannot delete..", severity: "error" })
      }
    },
    async deleteBucket() {
      // Defensive check: ensure bucket and bucket.id exist
      if (!this.bucket || !this.bucket.id) {
        console.warn("BucketTile: Cannot delete bucket - bucket or bucket.id is missing")
        this.showDeleteDialog = false
        return
      }
      this.showDeleteDialog = false
      await this.$store.dispatch("deleteBucket", this.bucket.id)
    },
    exportBucket() {
      // Defensive check: ensure bucket and bucket.id exist
      if (!this.bucket || !this.bucket.id) {
        console.warn("BucketTile: Cannot export bucket - bucket or bucket.id is missing")
        return
      }
      this.$store.dispatch("exportBucket", this.bucket.id)
    },
    setupBucket() {
      // Defensive check: ensure bucket and bucket.id exist
      if (!this.bucket || !this.bucket.id) {
        console.warn("BucketTile: Cannot setup bucket - bucket or bucket.id is missing")
        return
      }
      this.$store.dispatch("checkBucketBookmark", this.bucketRoute(this.caseTypeId, this.bucket.id), this.bookmarks)
      this.$router.push({
        name: "BucketEdit",
        params: { bucket_id: this.bucket.id, case_type_id: this.caseTypeId },
      })
    },
    async refreshStatistics() {
      // Defensive check: ensure bucket and bucket.id exist before making API call
      if (!this.bucket || !this.bucket.id) {
        console.warn("BucketTile: Cannot refresh statistics - bucket or bucket.id is missing", {
          bucket: this.bucket,
          component: "BucketTile"
        })
        this.statisticsLoading = false
        this.statistics = {}
        return
      }

      this.statisticsLoading = true
      try {
        const bucket = await provider.findBucket(this.bucket.id)
        
        // Defensive check: ensure bucket response exists
        if (!bucket) {
          console.warn("[BucketTile] Defensive: findBucket returned undefined/null", {
            bucketId: this.bucket.id,
            component: "BucketTile"
          })
          if (typeof window !== 'undefined' && window.__CB_DEBUG_BUCKET__) {
            console.log("[BucketTile] Defensive path: findBucket returned null", { bucketId: this.bucket.id, caseTypeId: this.caseTypeId })
          }
          Sentry.captureException(new Error("Bucket not found from API"), {
            tags: {
              component: "BucketTile",
              bucketId: this.bucket.id,
              caseTypeId: this.caseTypeId,
              caseTypeCode: this.caseTypeCode
            },
            extra: {
              bucket: this.bucket,
              statisticsLoading: this.statisticsLoading,
              routeId: this.routeId
            }
          })
          this.statistics = {}
          this.statisticsLoading = false
          return
        }

        // Defensive check: ensure bucket.contents exists before accessing
        if (bucket.contents && bucket.contents.statistics) {
          this.statistics = bucket.contents.statistics
        } else {
          Sentry.captureException(new Error("Bucket contents not found"), {
            tags: {
              component: "BucketTile",
              bucketId: this.bucket.id,
              caseTypeId: this.caseTypeId,
              caseTypeCode: this.caseTypeCode
            },
            extra: {
              bucket: this.bucket,
              fetchedBucket: bucket,
              statisticsLoading: this.statisticsLoading,
              routeId: this.routeId
            }
          })
          this.statistics = {}
        }
      } catch (error) {
        // Catch any errors during the API call or data processing
        console.error("BucketTile: Error refreshing statistics", error, {
          bucketId: this.bucket && this.bucket.id,
          component: "BucketTile"
        })
        Sentry.captureException(error, {
          tags: {
            component: "BucketTile",
            bucketId: this.bucket && this.bucket.id,
            caseTypeId: this.caseTypeId,
            caseTypeCode: this.caseTypeCode
          },
          extra: {
            bucket: this.bucket,
            statisticsLoading: this.statisticsLoading,
            routeId: this.routeId,
            errorMessage: error && error.message,
            errorStack: error && error.stack
          }
        })
        this.statistics = {}
      } finally {
        this.statisticsLoading = false
      }
    },
  },
  watch: {
    bucket() {
      if (this.showStatistics && this.statisticsLoaded) {
        this.statistics = {}
        this.refreshStatistics()
      }
    },
  },
  mounted() {
    if (!this.showStatistics) {
      this.statisticsLoading = false
      return
    }
    if (typeof IntersectionObserver === "undefined") {
      this.statisticsLoaded = true
      this.refreshStatistics()
      return
    }
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry && entry.isIntersecting && !this.statisticsLoaded) {
          this.statisticsLoaded = true
          this.refreshStatistics()
          if (this.$el && this.$el.nodeType === 1) this.intersectionObserver.unobserve(this.$el)
        }
      },
      { rootMargin: "50px", threshold: 0.01 }
    )
    this.$nextTick(() => {
      if (this.$el && this.$el.nodeType === 1) this.intersectionObserver.observe(this.$el)
    })
  },
  beforeDestroy() {
    if (this.intersectionObserver && this.$el && this.$el.nodeType === 1) {
      this.intersectionObserver.unobserve(this.$el)
    }
    this.intersectionObserver = null
  },
}
</script>

<style>
.bucket-lid {
  height: 15px;
  margin: 0 -4px -1px -4px;
  position: relative;
  z-index: 1;
}

.loading {
  align-items: start;
  justify-content: right;
  animation: rotation 1s infinite linear;
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.statistics-container {
  height: 20px;
}
</style>
